// name of the i18n folder
const ZH_TW = 'zh-tw';
const ZH_HK = 'zh-hk';
const EN_HK = 'en-hk';
const ZH_MY = 'zh-my';
const EN_MY = 'en-my';
const MS_MY = 'ms-my';
const EN_ID = 'en-id';
const ID_ID = 'id-id';
const EN_SG = 'en-sg';
const KO_KR = 'ko-kr';
const JA_JP = 'ja-jp';
const TH_TH = 'th-th';
const VI_VN = 'vi-vn';

const languages = {
  [ZH_TW]: ZH_TW,
  [ZH_HK]: ZH_HK,
  [EN_HK]: EN_HK,
  [ZH_MY]: ZH_MY,
  [EN_MY]: EN_MY,
  [MS_MY]: MS_MY,
  [EN_ID]: EN_ID,
  [ID_ID]: ID_ID,
  [EN_SG]: EN_SG,
  [KO_KR]: KO_KR,
  [JA_JP]: JA_JP,
  [TH_TH]: TH_TH,
  [VI_VN]: VI_VN,
};

module.exports.languages = languages;
module.exports.defaultLanguage = languages[EN_SG];



// WEBPACK FOOTER //
// ./app/constants/languages.js